import { FunctionComponent, useEffect, useRef, useState } from "react";
import "./QuestionSubType.scss";
import Table from "../../Components/Table/Table";
import CustomToolbar from "../../Components/Table/components/CustomToolbar";
import ButtonField from "../../Components/Button/ButtonField";
import { Columns } from "../../Components/Table/ITable";
import {
  GridRenderCellParams,
} from "@mui/x-data-grid";
import { IQuestionSubType } from "./IQuestionSubType";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import Dialog from "../../Components/Dialog/Dialog";
import QuestionSubTypeForm from "./QuestionSubTypeForm";
import ResponseDialog from "../../Components/ResponseDialog/ResponseDialog";
import TableSearch from "../../Components/Table/components/TableSearch";
import { ReactComponent as Delete } from "../../Assets/Images/delete.svg";
import { ReactComponent as Edit } from "../../Assets/Images/edit.svg";
import { IDeleteDialog } from "../../Components/DeleteDialog/IDeleteDialog";
import IconButtonField from "../../Components/Button/IconButtonField";
import { SvgIcon } from "@mui/material";
import DeleteDialog from "../../Components/DeleteDialog/DeleteDialog";
import { ReactComponent as RefreshButton } from "../../Assets/Images/RefreshButton.svg";
import { listQuestionType } from "../../Redux/Slices/QuestionType/ListQuestionTypeSlice";
import { clearAddQuestionSubTypeResponse } from "../../Redux/Slices/QuestionSubType/AddQuestionSubTypeSlice";
import {
  clearDeleteQuestionSubTypeResponse,
  deleteQuestionSubType,
} from "../../Redux/Slices/QuestionSubType/DeleteQuestionSubTypeSlice";
import { clearEditQuestionSubTypeResponse } from "../../Redux/Slices/QuestionSubType/EditQuestionSubTypeSlice";
import { listQuestionSubType } from "../../Redux/Slices/QuestionSubType/ListQuestionSubTypeSlice";

interface QuestionSubTypeProps { }
interface QuestionSubTypeProps { }

const QuestionSubType: FunctionComponent<QuestionSubTypeProps> = () => {
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState<boolean>(false);
  const [deleteDialogData, setDeleteData] = useState<IDeleteDialog>({});
  const [initialValues, setInitialValues] = useState<IQuestionSubType | {}>({
    status: true,
  });
  const dispatch = useAppDispatch();
  const { data: listQuestionSubTypes } = useAppSelector(
    (state) => state.ListQuestionSubTypeSlice
  );
  const { data: addQuestionSubTypeResponse } = useAppSelector(
    (state) => state.AddQuestionSubTypeSlice
  );
  const { data: EditQuestionSubTypeResponse } = useAppSelector(
    (state) => state.EditQuestionSubTypeSlice
  );
  const { data: deleteQuestionSubTypesResponse } = useAppSelector(
    (state) => state.DeleteQuestionSubType
  );
  // user permisssion
  const { data: userPermissionlist } = useAppSelector(
    (state) => state.SideMenuPermission
  );

  const to = "masters";

  const filteredList = Array.isArray(userPermissionlist?.Dashboard)
    ? userPermissionlist.Dashboard.filter((item: any) => item.to === to)
    : [];
  const fliterdata: any = filteredList.length > 0 ? filteredList[0]?.items : [];
  const finaldata = Array.isArray(fliterdata) ? fliterdata[0] : null;

  const formRef = useRef<HTMLFormElement>(null);
  const columns: Columns = [
    {
      field: "index",
      renderHeader: () => <b>S.No</b>,
      width: 90,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "subtype_name",
      renderHeader: () => <b>Name</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
    },
    {
      field: "question_type_name",
      renderHeader: () => <b>Question Type Name</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
    },
    {
      field: "status",
      renderHeader: () => <b>Status</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      cellClassName: (params) =>
        `activename ${params.row.status ? "active" : "inactive"}`,

      valueFormatter: (params) =>
        params.value === true ? "Active" : "Inactive",
    },
    {
      field: "action",
      renderHeader: () => <b>Action</b>,
      flex: 1,
      type: "actions",
      renderCell: (params: GridRenderCellParams<IQuestionSubType>) => {
        return (
          <>
            <IconButtonField
              disabled={finaldata?.permissions?.edit === false}
              onClick={() => {
                setInitialValues({ ...params.row, id: params.id as number });
                setIsEdit(true);
                setDialogOpen(true);
              }}
            >
              <SvgIcon sx={{ fill: "none" }} component={Edit} inheritViewBox />
            </IconButtonField>
            <IconButtonField
              disabled={finaldata?.permissions?.delete === false}
              onClick={() => {
                setDeleteData({
                  id: params.id,
                  name: params?.row?.subtype_name,
                });
                setDeleteDialogOpen(true);
              }}
            >
              <SvgIcon component={Delete} inheritViewBox />
            </IconButtonField>
          </>
        );
      },
    },
  ];

  const QuestionSubTypeRows: any[] = Array.isArray(listQuestionSubTypes?.data)
    ? (listQuestionSubTypes?.data.map((item: any, index: number) => ({
      ...item,
      index: index + 1,
    })) || [])
    : [];

  useEffect(() => {
    dispatch(listQuestionSubType({}));
    dispatch(listQuestionType());
  }, [
    addQuestionSubTypeResponse,
    EditQuestionSubTypeResponse,
    deleteQuestionSubTypesResponse,
    dispatch,
  ]);

  useEffect(() => {
    return () => {
      dispatch(clearAddQuestionSubTypeResponse());
      dispatch(clearEditQuestionSubTypeResponse());
      dispatch(clearDeleteQuestionSubTypeResponse());
    };
  }, [dispatch]);

  return (
    <>
      <Table rows={QuestionSubTypeRows} columns={columns}>
        <CustomToolbar>
          <h6></h6>
          <TableSearch />
          <ButtonField
            className="tabel_add_new_button"
            onClick={() => {
              setInitialValues({ status: true });
              setIsEdit(false);
              setDialogOpen(true);
            }}
            toolTip="Add new"
            disabled={finaldata?.permissions?.add === false}
          >
            Add new
          </ButtonField>
          <IconButtonField
            className="refresh_btn"
            toolTip="Refresh"
            onClick={() => dispatch(listQuestionSubType({}))}
          >
            <SvgIcon
              className="refresh_svg_icon"
              component={RefreshButton}
              inheritViewBox
            />
          </IconButtonField>
        </CustomToolbar>
      </Table>

      <Dialog
        open={dialogOpen}
        dialogClassName="dialog_double_input"
        Dialog_Title={`${isEdit ? "Update" : "Add"} Question Sub Type`}
        Dialog_Content={
          <QuestionSubTypeForm
            formRef={formRef}
            initialValues={initialValues as IQuestionSubType}
            setInitialValues={setInitialValues}
          />
        }
        Dialog_Actions={
          <>
            <ButtonField
              className="form_cancel_button"
              onClick={() => {
                setDialogOpen(false);
                setIsEdit(false);
              }}
            >
              Cancel
            </ButtonField>
            <ButtonField
              className="form_save_button"
              onClick={() => formRef.current?.requestSubmit()}
            >
              Save
            </ButtonField>
          </>
        }
      />
      <ResponseDialog
        response={addQuestionSubTypeResponse}
        parentDialog={setDialogOpen}
      />
      <ResponseDialog
        response={EditQuestionSubTypeResponse}
        parentDialog={setDialogOpen}
      />
      <DeleteDialog
        deleteableName={deleteDialogData.name ?? ""}
        open={deleteDialogOpen}
        setOpen={setDeleteDialogOpen}
        deleteFunction={() => {
          dispatch(deleteQuestionSubType(deleteDialogData.id));
        }}
        response={deleteQuestionSubTypesResponse}
      />
    </>
  );
};

export default QuestionSubType;

